import { IssueCaseMessageLinkDoc } from '@gooduncles/gu-app-schema';
import { useEffect, useState } from 'react';
import { map } from 'rxjs/operators';

import { observeIssueCaseMessageLinks } from 'src/utils/firebase/firebase-short-cut';

interface UseIssueCaseMessageLinksResult {
  links: IssueCaseMessageLinkDoc[];
  isLoading: boolean;
}

/**
 * issueCaseMessageLink (status='confirmed') 를 caseId 기준으로 messageCreatedAt asc 정렬해서 구독.
 * 인덱스: `issueCaseId ASC, status ASC, messageCreatedAt ASC` (gu-functions 1번 인덱스)
 */
const useIssueCaseMessageLinks = (issueCaseId: string | undefined): UseIssueCaseMessageLinksResult => {
  const [links, setLinks] = useState<IssueCaseMessageLinkDoc[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!issueCaseId) {
      setLinks([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const subscription = observeIssueCaseMessageLinks(
      [
        ['issueCaseId', '==', issueCaseId],
        ['status', '==', 'confirmed'],
      ],
      { sortKey: 'messageCreatedAt', orderBy: 'asc' },
    )
      .pipe(map((docs) => docs.filter((doc) => doc._timeDelete == null)))
      .subscribe({
        next: (docs) => {
          setLinks(docs);
          setIsLoading(false);
        },
        error: (error) => {
          console.error('[useIssueCaseMessageLinks] subscribe error', error);
          setIsLoading(false);
        },
      });

    return () => {
      subscription.unsubscribe();
    };
  }, [issueCaseId]);

  return { links, isLoading };
};

export default useIssueCaseMessageLinks;
